import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const removeGroups = async ({
	id,
	groupIds
}: {
	id: string;
	groupIds: number[];
}) => {
	const response = await cmsClient.delete<unknown>(
		`/homepage/admin/store/user/${id}/groups/`,
		{ data: { group_ids: groupIds } }
	);

	return response.data;
};

const useRemoveGroups = () => {
	const queryClient = useQueryClient();

	const onSuccess = (
		_: unknown,
		variables: { id: string; groupIds: number[] }
	) => {
		toast.success(<CustomToast type="Success" message="Groups removed" />, {
			hideProgressBar: true
		});

		queryClient.invalidateQueries(["person-profile", variables.id]);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	const mutation = useMutation(removeGroups, {
		onError,
		onSuccess
	});

	return mutation;
};

export default useRemoveGroups;
